import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { MessageProvider } from './context/MessageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Dashboard from './components/Dashboard';
import LogDuck from './components/LogDuck';
import Profile from './components/Profile';
import LogDetail from './components/LogDetail';
import Search from './components/Search';
import AdminPanel from './pages/AdminPanel';
import Messages from './pages/Messages';
import DevChat from './pages/DevChat';
import Changelog from './pages/Changelog';
import Imprint from './pages/Imprint';
import Privacy from './pages/Privacy';
import './App.css';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return null;
  }
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  if (loading) {
    return null;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  if (!user?.is_admin) {
    return <Navigate to="/dashboard" />;
  }
  return <>{children}</>;
};

function App() {
  return (
    <AuthProvider>
      <MessageProvider>
        <Router>
          <div className="App">
            <div className="app-gradient" />
            <Navbar />
            <main className="app-content">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route
                  path="/log-duck"
                  element={
                    <PrivateRoute>
                      <LogDuck />
                    </PrivateRoute>
                  }
                />
                <Route path="/profile/:userId" element={<Profile />} />
                <Route path="/log/:logId" element={<LogDetail />} />
                <Route
                  path="/admin"
                  element={
                    <AdminRoute>
                      <AdminPanel />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/search"
                  element={
                    <PrivateRoute>
                      <Search />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/messages"
                  element={
                    <PrivateRoute>
                      <Messages />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/dev-chat"
                  element={
                    <PrivateRoute>
                      <DevChat />
                    </PrivateRoute>
                  }
                />
                <Route path="/changelog" element={<Changelog />} />
                <Route path="/impressum" element={<Imprint />} />
                <Route path="/datenschutz" element={<Privacy />} />
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </MessageProvider>
    </AuthProvider>
  );
}

export default App;
